import { createContext } from "react";

export const StoreContext = createContext({});
export const StoreProvider = StoreContext.Provider;
